export const T = {
  en_GB: {
    edit: "Edit",
    delete: "Delete",
    productName: "Product Name",
    actions: "Actions",
    noProducts: "No products yet.",
    noProductsMatch: "No products match your search",
    notSet: "—",
  },
  nb_NO: {
    edit: "Rediger",
    delete: "Slett",
    productName: "Produktnavn",
    actions: "Handlinger",
    noProducts: "Ingen produkter ennå.",
    noProductsMatch: "Ingen produkter samsvarer med søket",
    notSet: "—",
  },
} as const;
